export const normalizeMusicTags = (rawTags) => {
  const tags = Array.isArray(rawTags)
    ? rawTags
    : (typeof rawTags === 'string' ? rawTags.split(',') : []);
  return tags
    .map((tag) => String(tag || '').trim().toLowerCase())
    .filter(Boolean);
};

export const isInstrumentalMusic = (music) => {
  if (!music) return false;
  const category = String(
    music.language_category || music.language || music.category || ''
  )
    .trim()
    .toLowerCase();
  if (category === 'instrumental' || category === 'pure') return true;

  const tags = normalizeMusicTags(music.tags);
  return tags.includes('instrumental') || tags.includes('纯音乐');
};
